import * as api from '@gitbook/api-client';
import { DateShortRelative } from '@gitbook/react-uikit';
import { CardLink, Heading } from '@gitbook/spine-react';

import { CopyableURL, getSiteTitle, SitePreviewIframe, SiteTypeBadge } from '../../Components';

/**
 * Pressable card to open a site.
 */
export function SiteListCard(props: {
    organization: api.Organization;
    item: api.OrganizationAllSite;
    modifiedDate: {
        date: Date;
        type: 'created' | 'updated';
    };
}) {
    const { item, organization, modifiedDate } = props;
    const { site } = item;

    return (
        <CardLink
            data-testid="site-list-card"
            href={{
                screen: { type: 'site', site: site.id },
            }}
            className="flex w-full flex-col gap-4 bg-base p-4"
        >
            <div>
                <SitePreviewIframe
                    site={site}
                    organization={organization}
                    className="aspect-video w-full rounded border"
                    scaleResolution={{
                        width: 1280,
                        height: 1280 / (16 / 9),
                    }}
                />
            </div>
            <div className="flex flex-col gap-1">
                <div className="flex flex-row gap-2">
                    <Heading>{getSiteTitle(site.title)}</Heading>
                    <SiteTypeBadge type={site.type} />
                </div>
                <div>
                    {(() => {
                        if (!site.published) {
                            return (
                                <p className="text-muted text-ui-small">
                                    Site is not published yet
                                </p>
                            );
                        }

                        if (site.visibility === api.SiteVisibility.ShareLink) {
                            return <p className="text-muted text-ui-small">Share links</p>;
                        }

                        if (site.urls.published) {
                            return (
                                <CopyableURL url={site.urls.published} className="text-ui-small" />
                            );
                        }
                    })()}
                </div>
                <div>
                    <p className="text-muted text-ui-small">
                        {modifiedDate.type === 'created' ? 'Created' : 'Updated'}{' '}
                        <DateShortRelative value={modifiedDate.date} onlyDate={false} />
                    </p>
                </div>
            </div>
        </CardLink>
    );
}
